import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../../page/style/style.css";
import { getUserDetails } from "../../../services/User_service";
import ButtonCustom from "../../../utils/custom-button";
import LoaderAnnonce from "../../../components/LoaderAnnonce";
import { createDemandeUserInfo } from "../../../services/demande_service";
import { ToastContainer, toast } from "react-toastify";
import { isValidRcs } from "../../../utils/functions/validateRCSNumber";
import Swal from "sweetalert2";
import { AxiosError } from "axios";
import axios from "../../../api/axios";
import CardCustomImage from "../../../components/CardCustomImage";
import tariffIcon from "../../../image/price3.png";
import { fetchPostalCodeDetails } from "../../../utils/functions/fetchPostalCodeDetails";
import {
  isSubscriber,
  subscribe,
  unSubscribe,
} from "../../../services/Mail_service";
import {
  Tag, Modal, Button, Card, Tabs, Badge,
  Segmented, Space, Divider, Alert, Form, Input, Select,
  Switch, Typography
} from "antd"; import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import useAppContext from "../../../hooks/useAppContext";
import { AppContextType } from "../../../context/AppContext";
import ProfessionalDocumentUpload from "../../register/ProfessionalDocumentUpload";
import RibModal from "../avoir/RibModal";
import { motion } from "framer-motion";
import { Avatar, Upload, Checkbox } from "antd";
import {
  UserOutlined,
  CameraOutlined,
  IdcardOutlined,
  BankOutlined,
  MailOutlined,
  PhoneOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  GlobalOutlined,
  BellOutlined,
  UploadOutlined,
  KeyOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  BuildOutlined,
  ManOutlined,
  EyeOutlined,
  DownloadOutlined,
  FileOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import "../../../styles/GestionDeMonCompte.css";

const { Option, OptGroup } = Select;
const { Text } = Typography;

interface InputWithTooltipProps {
  id: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  tooltipMessage: string;
  readOnly: boolean;
  type?: string;
  placeholder?: string;
}

const PROFESSION_OPTIONS: Record<string, string[]> = {
  "Professions juridiques": [
    "Administrateur / Mandataire judiciaire",
    "Avocat",
    "Clerc / Formaliste de notaire",
    "Greffier / Assistant de greffe",
    "Huissier de justice / Commissaire de justice",
    "Juriste d'entreprise",
    "Notaire",
  ],
  "Professions comptables": [
    "Cabinet comptable / Conseil en gestion",
    "Commissaire aux comptes",
    "Expert-comptable",
    "Gestionnaire de paie / RAF",
  ],
  "Créateurs et dirigeants d'entreprise": [
    "Dirigeant d'entreprise",
    "Entrepreneur individuel / Auto-entrepreneur",
    "Office manager / Responsable administratif",
  ],
  "Intermédiaires et formalistes": [
    "Agence de communication / Publicité",
    "Cabinet de formalités juridiques",
    "Formaliste en annonces légales",
    "Secrétaire juridique indépendant",
    "Société de domiciliation",
  ],
  "Autres professions": [
    "Administration / Assistance administrative",
    "Ressources humaines",
    "Responsable juridique",
    "Consultant indépendant",
  ],
  "Autre": ["Autre (à préciser)"]
};

// InputWithTooltip simplifié : plus de tooltip lié au bouton "Modifier"
const InputWithTooltip = ({
  id,
  value,
  onChange,
  tooltipMessage,
  readOnly,
  type = "text",
  placeholder
}: InputWithTooltipProps) => {
  return (
    <div className="modern-input-container">
      <div className="input-wrapper">
        <input
          type={type}
          id={id}
          className={`modern-input ${readOnly ? 'readonly' : ''}`}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

interface FormFieldProps {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  validationError?: string;
}

const FormField = ({ label, icon, children, validationError }: FormFieldProps) => {
  return (
    <div className="form-field-container">
      <div className="form-label-wrapper">
        <span className="form-label-icon">{icon}</span>
        <span className="form-label-text">{label}</span>
      </div>
      <div className="form-input-wrapper">
        {children}
      </div>
      {validationError && (
        <div className="validation-error">
          <InfoCircleOutlined />
          {validationError}
        </div>
      )}
    </div>
  );
};

const formatRIB = (rib: string) => {
  const clean = rib.replace(/\s+/g, "");
  if (clean.length !== 23) return rib;
  const bank = clean.slice(0, 5);
  const guichet = clean.slice(5, 10);
  const compte = clean.slice(10, 21);
  const cle = clean.slice(21);
  return `${bank} ${guichet} ${compte} ${cle}`;
};

function GestionDeMonCompte() {
  const location = useLocation();
  const [mounted, setMounted] = useState<boolean>(false);
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
  const [cities, setCities] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isProfessionalModalOpen, setIsProfessionalModalOpen] = useState<boolean>(false);
  const [ribModalVisible, setRibModalVisible] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("personal");
  const [userDocuments, setUserDocuments] = useState<any>(null);

  const [professionalRib, setProfessionalRib] = useState<string>("");
  const [professionalBic, setProfessionalBic] = useState<string>("");

  const [professionalDocuments, setProfessionalDocuments] = useState<{
    kbisFile: File | null;
    identityRecto: File | null;
    identityVerso: File | null;
    identityType: 'cin' | 'passeport';
    ribFile: File | null;
  }>({
    kbisFile: null,
    identityRecto: null,
    identityVerso: null,
    identityType: 'cin',
    ribFile: null
  });

  const [user, setUser] = useState({
    id: "",
    name: "",
    firstname: "",
    email: "",
    reference: "",
    civility: "",
    code_parrainage: "",
    adresse: "",
    number: "",
    country: "",
    postal_code: "",
    createdAt: "",
    raison_social: "",
    code_SIREN: "",
    code_NAF: "",
    tv_intra: "",
    user_type: "",
    status: "",
    profession: "",
    profession_other: "" as string | null,
    profession_is_other: false,
    is_professional: false,
    profile_picture: "",

    kbis_document: "",
    identity_document_recto: "",
    identity_document_verso: "",
    rib_document: "",
    identity_document_type: "" as 'cin' | 'passeport',
    documents_verified: false,
    documents_verification_date: "" as string | Date,
    rib: "",
    bic: "",
    account_number: "",
    bic_swift: "",
    show_in_directory: false,
    rgpd_directory_consent: false,
  });

  const [initialUser, setInitialUser] = useState(user);
  const [updatedInformations, setUpdatedInformations] = useState<Record<string, any>>({});
  const [selectedProfessionCategory, setSelectedProfessionCategory] = useState<string>("");
  const navigate = useNavigate();
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [profilePicture, setProfilePicture] = useState<File | null>(null);
  const [profilePicturePreview, setProfilePicturePreview] = useState<string | null>(null);
  const [form] = Form.useForm();

  const { setUserName, setUserFirstname } = useAppContext() as AppContextType;

  const [newDocuments, setNewDocuments] = useState<{
    kbis?: File | null;
    identityRecto?: File | null;
    identityVerso?: File | null;
    rib?: File | null;
  }>({});


  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  useEffect(() => {
    const hasDocChanges = Object.keys(newDocuments).some(
      key => newDocuments[key as keyof typeof newDocuments] !== null &&
        newDocuments[key as keyof typeof newDocuments] !== undefined
    );
    setHasChanges(Object.keys(updatedInformations).length > 0 || hasDocChanges);
  }, [updatedInformations, newDocuments]);

  // Fonction pour récupérer les documents professionnels
  const fetchProfessionalDocuments = async () => {
    try {
      if (user.user_type === "professionnel" || user.is_professional) {
        const response = await axios.get(`/user/${user.id}/documents`);
        setUserDocuments(response.data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des documents", error);
    }
  };

  // Fonction pour gérer le changement de profession
  const handleProfessionChange = (value: string) => {
    if (value === "Autre (à préciser)") {
      setUser((prev) => ({
        ...prev,
        profession: value,
        profession_is_other: true,
      }));

      setUpdatedInformations((prev) => ({
        ...prev,
        profession: value,
        profession_is_other: true,
      }));
    } else {
      setUser((prev) => ({
        ...prev,
        profession: value,
        profession_is_other: false,
        profession_other: "",
      }));

      const updatedInfo = { ...updatedInformations };
      if (value !== initialUser.profession) {
        updatedInfo.profession = value;
      } else {
        delete updatedInfo.profession;
      }
      delete updatedInfo.profession_other;
      delete updatedInfo.profession_is_other;
      setUpdatedInformations(updatedInfo);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const userData = await getUserDetails();
      if (userData) {
        const isOther = !!userData.profession_is_other;
        const formattedUser = {
          id: userData.id?.toString() || "",
          name: userData.name || "",
          firstname: userData.firstname || "",
          email: userData.email || "",
          reference: userData.reference || "",
          civility: userData.civility || "",
          code_parrainage: userData.code_parrainage || "",
          adresse: userData.adresse || "",
          number: userData.number || "",
          country: userData.country || "",
          postal_code: userData.postal_code || "",
          createdAt: userData.createdAt
            ? new Date(userData.createdAt).toLocaleDateString("fr-FR", {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
            : "",
          raison_social: userData.raison_social || "",
          code_SIREN: userData.code_SIREN || "",
          code_NAF: userData.code_NAF || "",
          tv_intra: userData.tv_intra || "",
          user_type: userData.user_type || "",
          status: userData.status || "",
          profession: isOther ? "Autre (à préciser)" : (userData.profession || ""),
          profession_other: userData.profession_other ?? "",
          profession_is_other: isOther,
          is_professional: userData.user_type === "professionnel" || false,
          profile_picture: userData.profile_picture || "",

          // Documents professionnels
          kbis_document: userData.kbis_document || "",
          identity_document_recto: userData.identity_document_recto || "",
          identity_document_verso: userData.identity_document_verso || "",
          rib_document: userData.rib_document || "",
          identity_document_type: userData.identity_document_type || 'cin',
          documents_verified: userData.documents_verified || false,
          documents_verification_date: userData.documents_verification_date || "",
          // Coordonnées bancaires
          rib: userData.rib || userData.account_number || "",
          bic: userData.bic_swift || "",
          account_number: userData.account_number || "",
          bic_swift: userData.bic_swift || "",
          show_in_directory: userData.show_in_directory || false,
          rgpd_directory_consent: userData.rgpd_directory_consent || false,
        };
        setUser(formattedUser);
        setInitialUser(formattedUser);

        if (!isOther && userData.profession) {
          for (const [category, professions] of Object.entries(PROFESSION_OPTIONS)) {
            if (professions.includes(userData.profession)) {
              setSelectedProfessionCategory(category);
              break;
            }
          }
        } else if (isOther) {
          setSelectedProfessionCategory("Autre");
        }

        setUserName(formattedUser.name);
        setUserFirstname(formattedUser.firstname);

        // Récupérer les documents si l'utilisateur est professionnel
        if (formattedUser.user_type === "professionnel" || formattedUser.is_professional) {
          await fetchProfessionalDocuments();
        }

        // Set form values
        form.setFieldsValue(formattedUser);
      }
      setLoading(false);
    };

    fetchUserData();
  }, [setUserName, setUserFirstname, form]);


  const docUrl = (path?: string) => {
    if (!path) return '';
    if (path.startsWith('http') || path.startsWith('blob:')) return path;
    const base = process.env.REACT_APP_API_BASE?.replace(/\/$/, '') || 'http://localhost:5200';
    return `${base}/${path.replace(/^\//, '')}`;
  };

  useEffect(() => {
    setHasChanges(Object.keys(updatedInformations).length > 0);
  }, [updatedInformations]);

  const handleForgotPassword = () => {
    navigate("/mail");
  };

  const handleCancel = () => {
    setUser(initialUser);
    setUpdatedInformations({});
    setNewDocuments({});
    form.setFieldsValue(initialUser);
  };

  const handleRcsInput = async (event: ChangeEvent<HTMLInputElement>) => {
    const rcs = event.target.value;
    setUser({ ...user, code_SIREN: rcs });
    form.setFieldValue('code_SIREN', rcs);

    if (rcs !== initialUser.code_SIREN) {
      setUpdatedInformations({ ...updatedInformations, code_SIREN: rcs });
    } else {
      const updatedInfo = { ...updatedInformations };
      delete updatedInfo.code_SIREN;
      setUpdatedInformations(updatedInfo);
    }

    if (isValidRcs(rcs)) {
      try {
        const response = await axios(`/rne/naf/${rcs}`);
        if (response) {
          const data = response.data.data;
          const raisonSociale = data.raison_sociale ||
            data.company_name ||
            data.denomination ||
            data.nom_entreprise || "";

          const updates = {
            code_SIREN: rcs,
            code_NAF: data.naf_code || "",
            tv_intra: data.vat_number || "",
            raison_social: raisonSociale,
            user_type: "entreprise",
          };

          setUser((prevUser) => ({ ...prevUser, ...updates }));
          setUpdatedInformations((prevInfo) => ({ ...prevInfo, ...updates }));
          form.setFieldsValue(updates);

          if (user.user_type === "personne") {
            Swal.fire({
              title: "Changement de statut",
              text: "En ajoutant un numéro SIREN valide, votre compte sera considéré comme une entreprise.",
              icon: "info",
              iconColor: "#ff8d3cd5",
              confirmButtonColor: "#2A919D",
              customClass: {
                popup: 'modern-swal'
              }
            });
          }
        }
      } catch (error: unknown) {
        const updates = {
          code_NAF: "",
          tv_intra: "",
          code_SIREN: rcs,
        };

        setUser({ ...user, ...updates });
        setUpdatedInformations({ ...updatedInformations, code_SIREN: rcs });
        form.setFieldsValue(updates);

        let message = "";
        if (error instanceof AxiosError) {
          message = error.response?.data?.message || error.message;
        } else {
          message = "Erreur inconnue : " + error;
        }
        Swal.fire({
          title: "Profil",
          icon: "error",
          text: message,
          showCloseButton: true,
          customClass: {
            popup: 'modern-swal'
          }
        });
      }
    }
  };

  const handleChangeInput = (
    event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>
  ) => {
    const { id, value } = event.target;
    setUser({ ...user, [id]: value });
    form.setFieldValue(id, value);

    if (id === "profession_other") {
      const newUpdated = { ...updatedInformations, profession_other: value, profession_is_other: true };
      setUpdatedInformations(newUpdated);
      setUser((prev) => ({ ...prev, profession: "Autre (à préciser)", profession_is_other: true }));
      return;
    }

    if (value !== initialUser[id as keyof typeof initialUser]) {
      const newUpdated = { ...updatedInformations, [id]: value };
      setUpdatedInformations(newUpdated);
    } else {
      const updatedInfo = { ...updatedInformations };
      delete updatedInfo[id];
      setUpdatedInformations(updatedInfo);
    }
  };

  const validatePhone = (value: string) => {
    const frenchPhoneRegex = /^(0\d{9}|\+33\d{9})$/;
    const europeanPhoneRegex = /^\+[1-9]\d{6,14}$/;
    const cleanValue = value.replace(/\s+/g, "");
    return frenchPhoneRegex.test(cleanValue) || europeanPhoneRegex.test(cleanValue);
  };

  // const handleSave = async () => {
  //   try {
  //     const isEntreprise = updatedInformations.user_type === "entreprise" ||
  //       (user.user_type === "entreprise" && !updatedInformations.user_type);

  //     const formData = new FormData();

  //     formData.append('user_id', user.id);
  //     formData.append('typeDemande', 'INFO_USER');

  //     const contentData: any = {
  //       id: user.id,
  //       ...updatedInformations
  //     };

  //     // ✅ Gestion de la profession "Autre"
  //     if (user.profession === "Autre (à préciser)" || user.profession_is_other) {
  //       contentData.profession_other = updatedInformations.profession_other ?? user.profession_other ?? '';
  //       contentData.profession_is_other = true;
  //       if (updatedInformations.profession_other) {
  //         contentData.profession = updatedInformations.profession_other;
  //       } else {
  //         contentData.profession = user.profession;
  //       }
  //     } else {
  //       contentData.profession_is_other = false;
  //       if (updatedInformations.profession) {
  //         contentData.profession = updatedInformations.profession;
  //       }
  //     }

  //     formData.append('content', JSON.stringify(contentData));

  //     if (isEntreprise) formData.append('is_entreprise', 'true');
  //     if (user.status === "anonymous") formData.append('status', 'active');

  //     // Documents professionnels
  //     if (newDocuments.kbis) {
  //       formData.append('kbis_document', newDocuments.kbis);
  //     }
  //     if (newDocuments.identityRecto) {
  //       formData.append('identity_document_recto', newDocuments.identityRecto);
  //     }
  //     if (newDocuments.identityVerso) {
  //       formData.append('identity_document_verso', newDocuments.identityVerso);
  //     }
  //     if (newDocuments.rib) {
  //       formData.append('rib_document', newDocuments.rib);
  //     }

  //     await createDemandeUserInfo(formData);

  //     Swal.fire({
  //       title: "Profil",
  //       icon: "success",
  //       text: "En attente de validation par l'admin",
  //       showCloseButton: true,
  //       customClass: {
  //         popup: 'modern-swal'
  //       }
  //     });

  //     // Mise à jour du contexte et localStorage
  //     if (updatedInformations.name) {
  //       setUserName(updatedInformations.name);
  //       localStorage.setItem('userName', updatedInformations.name);
  //     }
  //     if (updatedInformations.firstname) {
  //       setUserFirstname(updatedInformations.firstname);
  //       localStorage.setItem('userFirstname', updatedInformations.firstname);
  //     }

  //     if (user.status === "anonymous") {
  //       setUser((prevUser) => ({ ...prevUser, status: "active" }));
  //     }

  //     // Réinitialisation
  //     setUpdatedInformations({});
  //     setNewDocuments({});
  //     setHasChanges(false);

  //   } catch (error: unknown) {
  //     let message = "";
  //     if (error instanceof AxiosError) {
  //       message = error.response?.data?.message || error.message;
  //       console.error("Erreur Axios:", error.response?.data);
  //     } else {
  //       message = "Erreur inconnue : " + error;
  //     }
  //     Swal.fire({
  //       title: "Profil",
  //       icon: "error",
  //       text: message,
  //       showCloseButton: true,
  //       customClass: {
  //         popup: 'modern-swal'
  //       }
  //     });
  //   }
  //   setLoading(false);
  // };


const handleSave = async () => {
  try {
    console.log("========== DÉBUT HANDLE SAVE ==========");
    console.log("1. user.id:", user.id);
    console.log("2. updatedInformations AVANT traitement:", updatedInformations);
    console.log("3. user.rgpd_directory_consent:", user.rgpd_directory_consent);
    console.log("4. user.show_in_directory:", user.show_in_directory);
    console.log("5. initialUser.rgpd_directory_consent:", initialUser.rgpd_directory_consent);
    console.log("6. initialUser.show_in_directory:", initialUser.show_in_directory);
    
    const isEntreprise = updatedInformations.user_type === "entreprise" ||
      (user.user_type === "entreprise" && !updatedInformations.user_type);

    const formData = new FormData();

    formData.append('user_id', user.id);
    formData.append('typeDemande', 'INFO_USER');

    const contentData: any = {
      id: user.id,
      ...updatedInformations
    };

    console.log("7. contentData APRÈS spread updatedInformations:", contentData);

    // ✅ Gestion de la profession "Autre"
    if (user.profession === "Autre (à préciser)" || user.profession_is_other) {
      contentData.profession_other = updatedInformations.profession_other ?? user.profession_other ?? '';
      contentData.profession_is_other = true;
      if (updatedInformations.profession_other) {
        contentData.profession = updatedInformations.profession_other;
      } else {
        contentData.profession = user.profession;
      }
    } else {
      contentData.profession_is_other = false;
      if (updatedInformations.profession) {
        contentData.profession = updatedInformations.profession;
      }
    }

    console.log("8. contentData APRÈS gestion profession:", contentData);

    // 🔥 SOLUTION : FORCER l'inclusion des préférences d'annuaire
    // On ajoute TOUJOURS les valeurs actuelles de l'utilisateur
    contentData.rgpd_directory_consent = user.rgpd_directory_consent;
    contentData.show_in_directory = user.show_in_directory;

    console.log("9. contentData avec annuaire forcé:", {
      rgpd_directory_consent: contentData.rgpd_directory_consent,
      show_in_directory: contentData.show_in_directory
    });

    const contentString = JSON.stringify(contentData);
    console.log("10. contentString final:", contentString);
    
    formData.append('content', contentString);

    if (isEntreprise) {
      console.log("11. isEntreprise = true, ajout du champ");
      formData.append('is_entreprise', 'true');
    }
    
    if (user.status === "anonymous") {
      console.log("12. status anonymous, ajout status active");
      formData.append('status', 'active');
    }

    // Documents professionnels
    if (newDocuments.kbis) {
      console.log("13. Nouveau document KBIS:", newDocuments.kbis.name);
      formData.append('kbis_document', newDocuments.kbis);
    }
    if (newDocuments.identityRecto) {
      console.log("14. Nouveau document identityRecto:", newDocuments.identityRecto.name);
      formData.append('identity_document_recto', newDocuments.identityRecto);
    }
    if (newDocuments.identityVerso) {
      console.log("15. Nouveau document identityVerso:", newDocuments.identityVerso.name);
      formData.append('identity_document_verso', newDocuments.identityVerso);
    }
    if (newDocuments.rib) {
      console.log("16. Nouveau document rib:", newDocuments.rib.name);
      formData.append('rib_document', newDocuments.rib);
    }

    console.log("========== FIN PRÉPARATION, ENVOI VERS BACKEND ==========");

    await createDemandeUserInfo(formData);

    Swal.fire({
      title: "Profil",
      icon: "success",
      text: "En attente de validation par l'admin",
      showCloseButton: true,
      customClass: {
        popup: 'modern-swal'
      }
    });

    // Mise à jour du contexte et localStorage
    if (updatedInformations.name) {
      setUserName(updatedInformations.name);
      localStorage.setItem('userName', updatedInformations.name);
    }
    if (updatedInformations.firstname) {
      setUserFirstname(updatedInformations.firstname);
      localStorage.setItem('userFirstname', updatedInformations.firstname);
    }

    if (user.status === "anonymous") {
      setUser((prevUser) => ({ ...prevUser, status: "active" }));
    }

    // ✅ Mise à jour de initialUser avec les nouvelles valeurs
    setInitialUser(prev => ({
      ...prev,
      ...updatedInformations,
      rgpd_directory_consent: user.rgpd_directory_consent,
      show_in_directory: user.show_in_directory
    }));

    // Réinitialisation
    setUpdatedInformations({});
    setNewDocuments({});
    setHasChanges(false);

    console.log("========== FIN HANDLE SAVE ==========");

  } catch (error: unknown) {
    console.error("========== ERREUR DANS HANDLE SAVE ==========");
    console.error("Erreur:", error);
    
    let message = "";
    if (error instanceof AxiosError) {
      message = error.response?.data?.message || error.message;
      console.error("Erreur Axios:", error.response?.data);
    } else {
      message = "Erreur inconnue : " + error;
    }
    
    Swal.fire({
      title: "Profil",
      icon: "error",
      text: message,
      showCloseButton: true,
      customClass: {
        popup: 'modern-swal'
      }
    });
  }
  setLoading(false);
};

  const handleConfirm = () => {
    Swal.fire({
      title: "Modification de profil",
      text: "Voulez-vous continuer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuer",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#2A919D",
      cancelButtonColor: "#F4A261",
      customClass: {
        popup: 'modern-swal'
      }
    }).then((result) => {
      if (result.isConfirmed) handleSave();
    });
  };

  const handleProfessionalRequest = () => {
    setIsProfessionalModalOpen(true);
  };

  const handleRibConfirm = (rib: string, bic?: string) => {
    setProfessionalRib(rib);
    setProfessionalBic(bic || "");
    setRibModalVisible(false);
    toast.success("RIB saisi enregistré avec succès");
  };

  const handleProfessionalDocumentsSubmit = async () => {
    if (!professionalDocuments.kbisFile || !professionalDocuments.identityRecto) {
      toast.error("Veuillez remplir tous les documents requis");
      return;
    }

    if (professionalDocuments.identityType === 'cin' && !professionalDocuments.identityVerso) {
      toast.error("Veuillez télécharger le verso de la carte d'identité");
      return;
    }

    if (!professionalRib && !professionalDocuments.ribFile) {
      toast.error("Veuillez ajouter votre RIB (saisie manuelle OU document scanné)");
      return;
    }

    try {
      const formData = new FormData();
      formData.append('user_id', user.id);
      formData.append('request_type', 'professional_account');
      formData.append('identity_type', professionalDocuments.identityType);
      formData.append('kbis_document', professionalDocuments.kbisFile);
      formData.append('identity_document_recto', professionalDocuments.identityRecto);

      if (professionalRib) formData.append('rib', professionalRib);
      if (professionalBic) formData.append('bic', professionalBic);
      if (professionalDocuments.ribFile) formData.append('rib_document', professionalDocuments.ribFile);
      if (professionalDocuments.identityVerso) formData.append('identity_document_verso', professionalDocuments.identityVerso);

      formData.append('adresse', user.adresse || '');
      formData.append('number', user.number || '');
      formData.append('postal_code', user.postal_code || '');
      formData.append('country', user.country || '');

      await axios.put('/user/demande/professional', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      handleCloseProfessionalModal();
      Swal.fire({
        title: "Demande envoyée",
        text: "Votre demande de compte professionnel a été envoyée avec succès. Vous recevrez un email dès que l'admin aura validé votre demande.",
        icon: "success",
        confirmButtonColor: "#2A919D",
        customClass: {
          popup: 'modern-swal'
        }
      });
    } catch (error: unknown) {
      let message = "";
      if (error instanceof AxiosError) {
        message = error.response?.data?.message || error.message;
      } else {
        message = "Erreur lors de l'envoi de la demande";
      }
      Swal.fire({
        title: "Erreur",
        text: message,
        icon: "error",
        confirmButtonColor: "#2A919D",
        customClass: {
          popup: 'modern-swal'
        }
      });
    }
  };

  const handleSaveProfilePicture = async () => {
    if (!profilePicture) {
      toast.error("Aucune photo sélectionnée");
      return;
    }

    try {
      const formData = new FormData();
      formData.append('user_id', user.id);
      formData.append('typeDemande', 'PROFILE_PICTURE');
      formData.append('profile_picture', profilePicture);

      const contentData = {
        id: user.id,
        profile_picture: 'updated'
      };

      formData.append('content', JSON.stringify(contentData));

      await createDemandeUserInfo(formData);

      Swal.fire({
        title: "Photo de profil",
        icon: "success",
        text: "Demande de modification de photo envoyée. En attente de validation.",
        showCloseButton: true,
        customClass: {
          popup: 'modern-swal'
        }
      });

      // Réinitialisation
      setProfilePicture(null);
      setProfilePicturePreview(
        user.profile_picture
          ? `${process.env.REACT_APP_API_BASE}/${user.profile_picture}`
          : null
      );

    } catch (error: unknown) {
      let message = "";
      if (error instanceof AxiosError) {
        message = error.response?.data?.message || error.message;
      } else {
        message = "Erreur lors de l'envoi de la photo";
      }
      Swal.fire({
        title: "Erreur",
        icon: "error",
        text: message,
        showCloseButton: true,
        customClass: {
          popup: 'modern-swal'
        }
      });
    }
  };


  const handleCloseProfessionalModal = () => {
    setIsProfessionalModalOpen(false);
    setProfessionalRib("");
    setProfessionalBic("");
    setProfessionalDocuments({
      kbisFile: null,
      identityRecto: null,
      identityVerso: null,
      identityType: 'cin',
      ribFile: null
    });
  };

  const handleSubscribeToggle = async () => {
    try {
      if (isSubscribed) {
        await unSubscribe();
        setIsSubscribed(false);
        toast.success("Vous êtes maintenant non abonné");
      } else {
        await subscribe();
        setIsSubscribed(true);
        toast.success("Vous êtes maintenant abonné");
      }
    } catch (error) {
      toast.error("Erreur lors du changement d'abonnement");
      setIsSubscribed((prevState) => !prevState);
    }
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const postalDetails = await fetchPostalCodeDetails(user.postal_code);
        setCities(postalDetails?.cities || []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCities();
  }, [user.postal_code]);

  useEffect(() => {
    if (!mounted) {
      isSubscriber().then((response: any) => {
        setIsSubscribed(response.subscribed);
        setMounted(true);
      });
    }
  }, [mounted]);

  useEffect(() => {
    if (user.id && user.profile_picture) {
      const normalizedPath = user.profile_picture.replace(/\\/g, '/');
      const photoPath = `${process.env.REACT_APP_API_BASE}/${normalizedPath}`;
      setProfilePicturePreview(photoPath);
    } else {
      setProfilePicturePreview(null);
    }
  }, [user]);

  useEffect(() => {
    const state = location.state as { activeTab?: string; scrollTo?: string } | null;
    if (state?.activeTab) {
      setActiveTab(state.activeTab);
    }
    if (state?.scrollTo === "directory") {
      setTimeout(() => {
        const el = document.getElementById("directory-visibility-section");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.style.transition = "box-shadow 0.3s";
          el.style.boxShadow = "0 0 0 3px #4bb0c0";
          setTimeout(() => {
            el.style.boxShadow = "none";
          }, 2000);
        }
      }, 400);
    }
  }, [location.state]);

  const handleFileChange = (info: any) => {
    const file = info.file.originFileObj as File;
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Fichier trop volumineux (max 5MB)");
      return;
    }

    setProfilePicture(file);
    setProfilePicturePreview(URL.createObjectURL(file));
    setHasChanges(true);
  };

  const handleCancelPhotoChange = () => {
    setProfilePicture(null);
    setProfilePicturePreview(
      user.profile_picture
        ? `${process.env.REACT_APP_API_BASE}/${user.profile_picture}`
        : null
    );
    setHasChanges(false);
  };

  const customRequest = ({ file, onSuccess }: any) => {
    setTimeout(() => onSuccess("ok"), 0);
  };

  if (loading) {
    return <LoaderAnnonce />;
  }

  const isProfessional = user.user_type === "professionnel" || user.is_professional;

  const renderProfilePictureSection = () => (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeInUp}
      transition={{ duration: 0.3 }}
    >
      <Card className="profile-card">
        <div className="profile-header">
          <div className="avatar-section">
            <Avatar
              size={120}
              src={profilePicturePreview}
              icon={!profilePicturePreview && <UserOutlined />}
              className="profile-avatar"
            />
            <Upload
              customRequest={customRequest}
              onChange={handleFileChange}
              showUploadList={false}
              accept="image/jpeg,image/png,image/jpg"
            >
              <div className="avatar-upload-btn">
                <CameraOutlined />
              </div>
            </Upload>
          </div>
          <div className="profile-info">
            <h3 className="profile-name">
              {user.civility === "madame" ? "Mme" : "M."} {user.firstname} {user.name}
            </h3>
            <div className="profile-meta">
              <Badge
                status={user.status === "active" ? "success" : "warning"}
                text={user.status === "active" ? "Compte actif" : user.status === "inactive" ? "Compte inactif" : "En attente"}
              />
              <span className="profile-reference">
                <IdcardOutlined /> Réf: {user.reference}
              </span>
            </div>
            <div className="profile-type">
              <Tag
                color={
                  user.user_type === "entreprise"
                    ? "#2A919D"
                    : user.user_type === "professionnel"
                      ? "#4BB0C0"
                      : "#eb8635"
                }
              >
                {user.user_type === "entreprise"
                  ? "Entreprise"
                  : user.user_type === "professionnel"
                    ? "Professionnel"
                    : "Particulier"}
              </Tag>
              {user.is_professional && (
                <Tag
                  color="#2A919D"
                  icon={<CheckCircleOutlined />}
                  className="tag-verified"
                >
                  Professionnel vérifié
                </Tag>
              )}
            </div>
          </div>
        </div>

        {profilePicture && (
          <Alert
            message="Photo de profil modifiée"
            description="Vous avez sélectionné une nouvelle photo. Enregistrez pour soumettre la modification."
            type="info"
            showIcon
            className="mt-3"
          />
        )}

        {profilePicture && (
          <div className="profile-actions">
            <ButtonCustom
              title="Enregistrer la photo"
              color="#4bb0c0"
              onClick={handleSaveProfilePicture}
            />
            <ButtonCustom
              title="Annuler"
              color="#f4a261"
              onClick={handleCancelPhotoChange}
            />
          </div>
        )}
      </Card>
    </motion.div>
  );


  return (
    <>
      <ToastContainer />

      <RibModal
        visible={ribModalVisible}
        onCancel={() => setRibModalVisible(false)}
        onConfirm={handleRibConfirm}
        requireBic={true}
      />

      <div className="gestion-compte-container">
        {renderProfilePictureSection()}

        {!isProfessional && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            transition={{ duration: 0.4 }}
            className="professional-upgrade-section"
          >
            <Card className="upgrade-card">
              <div className="upgrade-content">
                <div className="upgrade-icon">
                  <BuildOutlined />
                </div>
                <div className="upgrade-text">
                  <h4>Passez au compte professionnel</h4>
                  <p>Gagnez plus de remises et des avantages exclusifs</p>
                </div>
                <ButtonCustom
                  title="Demander un compte professionnel"
                  color="#2A919D"
                  onClick={handleProfessionalRequest}
                />
              </div>
            </Card>
          </motion.div>
        )}

        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ duration: 0.5 }}
        >
          <Card className="main-content-card">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              className="custom-tabs"
              items={[
                {
                  key: "personal",
                  label: (
                    <span>
                      <UserOutlined className="section-icon" /> Informations personnelles
                    </span>
                  ),
                  children: (
                    <Form
                      form={form}
                      layout="vertical"
                      className="info-form"
                    >
                      <div className="form-section">
                        <div className="form-grid form-grid-3">

                          <Form.Item className="form-item">
                            <FormField
                              label="Civilité"
                              icon={<ManOutlined />}
                            >
                              <Select
                                value={user.civility}
                                onChange={(value) => handleChangeInput({ target: { id: 'civility', value } } as any)}
                                className="modern-select"
                                placeholder="Sélectionner"
                              >
                                <Option value="monsieur">Monsieur</Option>
                                <Option value="madame">Madame</Option>
                              </Select>
                            </FormField>
                          </Form.Item>
                          <Form.Item className="form-item">
                            <FormField
                              label="Nom"
                              icon={<UserOutlined />}
                            >
                              <InputWithTooltip
                                id="name"
                                value={user.name}
                                onChange={handleChangeInput}
                                tooltipMessage=""
                                readOnly={false}
                                placeholder="Votre nom"
                              />
                            </FormField>
                          </Form.Item>

                          <Form.Item className="form-item">
                            <FormField
                              label="Prénom"
                              icon={<UserOutlined />}
                            >
                              <InputWithTooltip
                                id="firstname"
                                value={user.firstname}
                                onChange={handleChangeInput}
                                tooltipMessage=""
                                readOnly={false}
                                placeholder="Votre prénom"
                              />
                            </FormField>
                          </Form.Item>
                        </div>
                      </div>

                      <Divider />

                      <div className="form-section">
                        <div className="form-grid form-grid-2">
                          <Form.Item className="form-item">
                            <FormField
                              label="Email"
                              icon={<MailOutlined />}
                            >
                              <InputWithTooltip
                                id="email"
                                value={user.email}
                                onChange={handleChangeInput}
                                tooltipMessage=""
                                readOnly={false}
                                type="email"
                                placeholder="email@exemple.com"
                              />
                            </FormField>
                          </Form.Item>

                          <Form.Item className="form-item">
                            <div className="form-field-with-error">
                              <div className="form-field-horizontal">
                                <div className="form-label-wrapper">
                                  <PhoneOutlined className="form-label-icon" />
                                  <span className="form-label-text">Téléphone</span>
                                </div>
                                <div className="form-input-wrapper">
                                  <InputWithTooltip
                                    id="number"
                                    value={user.number}
                                    onChange={handleChangeInput}
                                    tooltipMessage=""
                                    readOnly={false}
                                    placeholder="+33 1 23 45 67 89"
                                  />
                                </div>
                              </div>

                              {user.number && !validatePhone(user.number) && (
                                <div className="phone-error-message">
                                  <InfoCircleOutlined />
                                  <span>Format de téléphone invalide</span>
                                </div>
                              )}
                            </div>
                          </Form.Item>
                        </div>
                      </div>

                      <Divider />

                      <div className="form-section">
                        <div className="form-grid form-grid-3">
                          <Form.Item className="form-item">
                            <FormField
                              label="Adresse"
                              icon={<HomeOutlined />}
                            >
                              <InputWithTooltip
                                id="adresse"
                                value={user.adresse}
                                onChange={handleChangeInput}
                                tooltipMessage=""
                                readOnly={false}
                                placeholder="Adresse complète"
                              />
                            </FormField>
                          </Form.Item>

                          <Form.Item className="form-item">
                            <FormField
                              label="Code postal"
                              icon={<EnvironmentOutlined />}
                            >
                              <InputWithTooltip
                                id="postal_code"
                                value={user.postal_code}
                                onChange={handleChangeInput}
                                tooltipMessage=""
                                readOnly={false}
                                placeholder="75000"
                              />
                            </FormField>
                          </Form.Item>

                          <Form.Item className="form-item">
                            <FormField
                              label="Ville"
                              icon={<EnvironmentOutlined />}
                            >
                              <Select
                                value={user.country}
                                onChange={(value) => handleChangeInput({ target: { id: 'country', value } } as any)}
                                className="modern-select"
                                placeholder="Sélectionner une ville"
                              >
                                {cities.map((city, index) => (
                                  <Option key={index} value={city}>{city}</Option>
                                ))}
                              </Select>
                            </FormField>
                          </Form.Item>
                        </div>
                      </div>
                    </Form>
                  ),
                },
                {
                  key: "professional",
                  label: (
                    <span>
                      <BuildOutlined style={{ marginRight: '8px' }} />
                      Informations Entreprises
                    </span>

                  ),
                  children: (
                    <div className="info-form">
                      <div className="form-grid form-grid-2">
                        <Form.Item className="form-item">
                          <FormField
                            label="Raison sociale"
                            icon={<BankOutlined />}
                          >
                            <InputWithTooltip
                              id="raison_social"
                              value={user.raison_social}
                              onChange={handleChangeInput}
                              tooltipMessage=""
                              readOnly={false}
                              placeholder="Raison sociale"
                            />
                          </FormField>
                        </Form.Item>

                        <Form.Item className="form-item">
                          <FormField
                            label="SIREN"
                            icon={<IdcardOutlined />}
                          >
                            <InputWithTooltip
                              id="code_SIREN"
                              value={user.code_SIREN}
                              onChange={handleRcsInput}
                              tooltipMessage=""
                              readOnly={false}
                              placeholder="123 456 789"
                            />
                          </FormField>
                        </Form.Item>
                      </div>

                      <div className="form-grid form-grid-2">
                        <Form.Item className="form-item">
                          <FormField
                            label="Code NAF"
                            icon={<FileTextOutlined />}
                          >
                            <InputWithTooltip
                              id="code_NAF"
                              value={user.code_NAF}
                              onChange={handleChangeInput}
                              tooltipMessage=""
                              readOnly={false}
                              placeholder="Code NAF"
                            />
                          </FormField>
                        </Form.Item>

                        <Form.Item className="form-item">
                          <FormField
                            label="TVA Intracommunautaire"
                            icon={<GlobalOutlined />}
                          >
                            <InputWithTooltip
                              id="tv_intra"
                              value={user.tv_intra}
                              onChange={handleChangeInput}
                              tooltipMessage=""
                              readOnly={false}
                              placeholder="FRXX 123456789"
                            />
                          </FormField>
                        </Form.Item>
                      </div>

                      <div className="form-grid form-grid-1">
                        <Form.Item className="form-item">
                          <FormField
                            label="Profession"
                            icon={<UserOutlined />}
                          >
                            <div className="modern-select-wrapper">
                              <Select
                                value={user.profession || undefined}
                                onChange={handleProfessionChange}
                                className="modern-select"
                                placeholder="Sélectionner une profession"
                              >
                                {Object.entries(PROFESSION_OPTIONS).map(([category, professions]) => (
                                  <OptGroup key={category} label={category}>
                                    {professions.map((prof) => (
                                      <Option key={prof} value={prof}>
                                        {prof}
                                      </Option>
                                    ))}
                                  </OptGroup>
                                ))}
                              </Select>
                            </div>

                            {user.profession === "Autre (à préciser)" && (
                              <div className="mt-3">
                                <Input
                                  value={user.profession_other || ""}
                                  onChange={(e) => handleChangeInput({ target: { id: 'profession_other', value: e.target.value } } as any)}
                                  placeholder="Précisez votre métier"
                                  className="modern-input"
                                />
                              </div>
                            )}
                          </FormField>
                        </Form.Item>
                        {(user.user_type === "professionnel" || user.user_type === "entreprise") && (
                        <Form.Item id="directory-visibility-section" className="form-item" style={{ gridColumn: '1 / -1' }}>
                            <Divider>Visibilité dans l'annuaire</Divider>

                            {/* ── Consentement RGPD ── */}
                            <div style={{
                              padding: '16px 20px',
                              border: `1.5px solid ${user.rgpd_directory_consent ? '#2A919D' : '#e8e8e8'}`,
                              borderRadius: 12,
                              background: user.rgpd_directory_consent ? '#f0fafa' : '#fafafa',
                              marginBottom: 16,
                              transition: 'all 0.3s ease'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, fontWeight: 600 }}>
                                <SafetyCertificateOutlined style={{ color: '#2A919D', fontSize: 18 }} />
                                <span>Consentement RGPD requis</span>
                                {user.rgpd_directory_consent && (
                                  <Tag color="#2A919D" icon={<CheckCircleOutlined />} style={{ marginLeft: 4 }}>
                                    Accepté
                                  </Tag>
                                )}
                              </div>

                              <p style={{ fontSize: 13, color: '#666', marginBottom: 14, lineHeight: 1.6 }}>
                                Avant d'apparaître dans l'annuaire professionnel, vous devez accepter notre politique
                                de confidentialité concernant la collecte et l'utilisation de vos données personnelles.
                              </p>
                              <Checkbox
                            checked={user.rgpd_directory_consent || false}
                            onChange={(e) => {
                              const accepted = e.target.checked;
                              
                              console.log("=== DEBUG CHECKBOX RGPD ===");
                              console.log("accepted:", accepted);
                              console.log("initialUser.show_in_directory:", initialUser.show_in_directory);
                              console.log("user.show_in_directory avant:", user.show_in_directory);
                              
                              const updates: any = { 
                                rgpd_directory_consent: accepted,
                                show_in_directory: accepted ? true : false 
                              };
                              
                              console.log("updates:", updates);
                              
                              setUser({ ...user, ...updates });
                              
                              const newUpdated = { ...updatedInformations, ...updates };
                              console.log("newUpdated avant nettoyage:", newUpdated);
                              
                              if (accepted === initialUser.rgpd_directory_consent) {
                                delete newUpdated.rgpd_directory_consent;
                                console.log("rgpd_directory_consent supprimé (identique à initial)");
                              }
                              
                              if (updates.show_in_directory === initialUser.show_in_directory) {
                                delete newUpdated.show_in_directory;
                                console.log("show_in_directory supprimé (identique à initial)");
                              } else {
                                console.log("show_in_directory CONSERVÉ (différent de l'initial)");
                              }
                              
                              console.log("newUpdated après nettoyage:", newUpdated);
                              console.log("========================");
                              
                              setUpdatedInformations(newUpdated);
                            }}
                          >
                                                          <span style={{ fontSize: 13, marginBottom: 0 }}>
                                  J'ai lu et j'accepte la&nbsp;
                                  <Typography.Link
                                    href="https://annonce-legale-officielle.fr/politique-de-confidentialite/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ color: '#2A919D', fontWeight: 600, textDecoration: 'none', marginTop: 1 }}
                                  >
                                    politique de confidentialité (RGPD)
                                  </Typography.Link>
                                  &nbsp; et j'accepte que mes informations professionnelles soient visibles dans l'annuaire.
                                </span>
                              </Checkbox>
                            </div>

                            {/* ── Visibilité annuaire — toujours affiché, grisé si RGPD non accepté ── */}
                            <div style={{
                              opacity: user.rgpd_directory_consent ? 1 : 0.45,
                              pointerEvents: user.rgpd_directory_consent ? 'auto' : 'none',
                              transition: 'opacity 0.3s ease',
                              cursor: user.rgpd_directory_consent ? 'auto' : 'not-allowed',
                            }}>
                              <FormField
                                label="Apparaître dans l'annuaire professionnel"
                                icon={<EyeOutlined />}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                  <Switch
                                    checked={user.show_in_directory || false}
                                    onChange={(checked) => {
                                      if (!user.rgpd_directory_consent) return;
                                      setUser({ ...user, show_in_directory: checked });
                                      if (checked !== initialUser.show_in_directory) {
                                        setUpdatedInformations({ ...updatedInformations, show_in_directory: checked });
                                      } else {
                                        const updated = { ...updatedInformations };
                                        delete updated.show_in_directory;
                                        setUpdatedInformations(updated);
                                      }
                                    }}
                                    checkedChildren="Visible"
                                    unCheckedChildren="Masqué"
                                    disabled={!user.rgpd_directory_consent}
                                  />
                                  <Text type="secondary" style={{ fontSize: 12 }}>
                                    {user.show_in_directory && user.rgpd_directory_consent
                                      ? "Votre profil est visible dans l'annuaire des professionnels"
                                      : user.rgpd_directory_consent
                                        ? "Votre profil est masqué de l'annuaire"
                                        : "Acceptez la politique de confidentialité pour activer cette option"}
                                  </Text>
                                </div>
                              </FormField>
                            </div>

                            </Form.Item>
                          )}
                      </div>
                    </div>
                  ),
                },

                {
                  key: "documents",
                  label: (
                    <span>
                      <FileOutlined style={{ marginRight: '8px' }} /> Documents
                    </span>
                  ),
                  children: (
                    <div className="documents-section">
                      <h5 className="section-title">
                        <FileOutlined /> Documents professionnels
                      </h5>
                      {isProfessional ? (
                        <div className="documents-professional-container">
                          {/* Statut de vérification */}
                          <Alert
                            message={
                              <div className="verification-status-wrapper">
                                <span>Statut de vérification : </span>
                                {user.documents_verified ? (
                                  <Tag className="tag-verified ms-2" color="#2A919D" icon={<CheckCircleOutlined />}>
                                    ✓ Vérifié
                                  </Tag>
                                ) : (
                                  <Tag color="#F4A261">En attente de vérification</Tag>
                                )}
                              </div>
                            }
                            description={
                              user.documents_verification_date ? (
                                `Vérifié le : ${new Date(user.documents_verification_date).toLocaleDateString('fr-FR')}`
                              ) : null
                            }
                            type={user.documents_verified ? "success" : "info"}
                            showIcon
                            className="mb-4"
                          />

                          {/* Section coordonnées bancaires */}
                          <Card className="mb-4">
                            <div className="document-header">
                              <BankOutlined className="document-icon" />
                              <h6>Coordonnées bancaires</h6>
                            </div>
                            <div className="document-content">
                              <div className="rib-fields-container">
                                <div className="rib-fields-grid">
                                  <FormField
                                    label="RIB / IBAN"
                                    icon={<BankOutlined />}
                                  >
                                    <InputWithTooltip
                                      id="rib"
                                      value={user.rib || user.account_number || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setUser({ ...user, rib: value, account_number: value });
                                        form.setFieldValue('rib', value);
                                        if (value !== initialUser.rib && value !== initialUser.account_number) {
                                          setUpdatedInformations({
                                            ...updatedInformations,
                                            rib: value,
                                            account_number: value
                                          });
                                        } else {
                                          const updated = { ...updatedInformations };
                                          delete updated.rib;
                                          delete updated.account_number;
                                          setUpdatedInformations(updated);
                                        }
                                      }}
                                      tooltipMessage=""
                                      readOnly={false}
                                      placeholder="FR76 1234 5678 9012 3456 7890 123"
                                    />
                                  </FormField>

                                  <FormField
                                    label="BIC / SWIFT"
                                    icon={<BankOutlined />}
                                  >
                                    <InputWithTooltip
                                      id="bic_swift"
                                      value={user.bic || user.bic_swift || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setUser({ ...user, bic: value, bic_swift: value });
                                        form.setFieldValue('bic_swift', value);
                                        if (value !== initialUser.bic && value !== initialUser.bic_swift) {
                                          setUpdatedInformations({
                                            ...updatedInformations,
                                            bic: value,
                                            bic_swift: value
                                          });
                                        } else {
                                          const updated = { ...updatedInformations };
                                          delete updated.bic;
                                          delete updated.bic_swift;
                                          setUpdatedInformations(updated);
                                        }
                                      }}
                                      tooltipMessage=""
                                      readOnly={false}
                                      placeholder="BNPAFRPPXXX"
                                    />
                                  </FormField>
                                </div>

                                {(user.rib || user.account_number || user.bic || user.bic_swift) && (
                                  <div className="rib-saved-info">
                                    <div className="rib-saved-grid">
                                      {(user.rib || user.account_number) && (
                                        <div className="rib-saved-item">
                                          <strong className="rib-label">RIB enregistré :</strong>
                                          <div className="rib-value">
                                            {formatRIB(user.rib || user.account_number)}
                                          </div>
                                        </div>
                                      )}
                                      {(user.bic || user.bic_swift) && (
                                        <div className="rib-saved-item">
                                          <strong className="rib-label">BIC/SWIFT enregistré :</strong>
                                          <div className="rib-value">
                                            {user.bic || user.bic_swift}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Card>

                          <Divider />

                          {/* Documents grid avec possibilité de modification */}
                          <div className="documents-grid">
                            {/* Carte KBIS */}
                            <Card className="document-card">
                              <div className="document-header">
                                <FileTextOutlined className="document-icon" />
                                <h6>Extrait KBIS</h6>
                                {(user.kbis_document || newDocuments.kbis) && (
                                  <Tag color="#2A919D" className="tag-verified">
                                    <CheckCircleOutlined /> {newDocuments.kbis ? 'Nouveau' : 'Disponible'}
                                  </Tag>
                                )}
                              </div>
                              <div className="document-content">
                                <div className="upload-container">
                                  <Upload
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    maxCount={1}
                                    beforeUpload={(file) => {
                                      if (file.size > 5 * 1024 * 1024) {
                                        toast.error("Fichier trop volumineux (max 5MB)");
                                        return false;
                                      }
                                      setNewDocuments({ ...newDocuments, kbis: file });
                                      setUpdatedInformations({ ...updatedInformations, kbis_document: 'updated' });
                                      setHasChanges(true);
                                      return false;
                                    }}
                                    onRemove={() => {
                                      setNewDocuments({ ...newDocuments, kbis: null });
                                      const updated = { ...updatedInformations };
                                      delete updated.kbis_document;
                                      setUpdatedInformations(updated);
                                    }}
                                  >
                                    <Button icon={<UploadOutlined />} block className="upload-button">
                                      {newDocuments.kbis ? 'Modifier le KBIS' : user.kbis_document ? 'Remplacer le KBIS' : 'Uploader le KBIS'}
                                    </Button>
                                  </Upload>
                                  {newDocuments.kbis && (
                                    <div className="upload-file-name">
                                      Nouveau fichier : {newDocuments.kbis.name}
                                    </div>
                                  )}
                                  {!newDocuments.kbis && user.kbis_document && (
                                    <div className="document-actions mt-2">
                                      <Button
                                        type="link"
                                        icon={<EyeOutlined />}
                                        href={docUrl(user.kbis_document)}
                                        target="_blank"
                                        className="btn-view"
                                      >
                                        Voir le document
                                      </Button>
                                      <Button
                                        type="link"
                                        icon={<DownloadOutlined />}
                                        href={docUrl(user.kbis_document)}
                                        download
                                        className="btn-view"
                                      >
                                        Télécharger
                                      </Button>
                                    </div>
                                  )}
                                  {!newDocuments.kbis && !user.kbis_document && (
                                    <div className="no-document">
                                      Aucun document disponible
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Card>

                            {/* Carte Pièce d'identité Recto */}
                            <Card className="document-card">
                              <div className="document-header">
                                <IdcardOutlined className="document-icon" />
                                <h6>Pièce d'identité - Recto</h6>
                                {(user.identity_document_recto || newDocuments.identityRecto) && (
                                  <Tag color="#2A919D" className="tag-verified">
                                    <CheckCircleOutlined /> {newDocuments.identityRecto ? 'Nouveau' : 'Disponible'}
                                  </Tag>
                                )}
                              </div>
                              <div className="document-content">
                                <div className="upload-container">
                                  <Upload
                                    accept=".jpg,.jpeg,.png"
                                    maxCount={1}
                                    listType="picture-card"
                                    beforeUpload={(file) => {
                                      if (file.size > 5 * 1024 * 1024) {
                                        toast.error("Fichier trop volumineux (max 5MB)");
                                        return false;
                                      }
                                      setNewDocuments({ ...newDocuments, identityRecto: file });
                                      setUpdatedInformations({ ...updatedInformations, identity_document_recto: 'updated' });
                                      setHasChanges(true);
                                      return false;
                                    }}
                                    onRemove={() => {
                                      setNewDocuments({ ...newDocuments, identityRecto: null });
                                      const updated = { ...updatedInformations };
                                      delete updated.identity_document_recto;
                                      setUpdatedInformations(updated);
                                    }}
                                  >
                                    {newDocuments.identityRecto ? null : (
                                      <div>
                                        <UploadOutlined />
                                        <div className="mt-2">
                                          {user.identity_document_recto ? 'Remplacer' : 'Upload'}
                                        </div>
                                      </div>
                                    )}
                                  </Upload>
                                  {newDocuments.identityRecto && (
                                    <div className="upload-file-name">
                                      Nouveau fichier : {newDocuments.identityRecto.name}
                                    </div>
                                  )}
                                  {!newDocuments.identityRecto && user.identity_document_recto && (
                                    <div className="document-actions mt-2">
                                      <Button
                                        type="link"
                                        icon={<EyeOutlined />}
                                        href={docUrl(user.identity_document_recto)}
                                        target="_blank"
                                        className="btn-view"
                                      >
                                        Voir
                                      </Button>
                                      <Button
                                        type="link"
                                        icon={<DownloadOutlined />}
                                        href={docUrl(user.identity_document_recto)}
                                        download
                                        className="btn-view"
                                      >
                                        Télécharger
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Card>

                            {/* Carte Pièce d'identité Verso */}
                            {user.identity_document_type === 'cin' && (
                              <Card className="document-card">
                                <div className="document-header">
                                  <IdcardOutlined className="document-icon" />
                                  <h6>Pièce d'identité - Verso</h6>
                                  {(user.identity_document_verso || newDocuments.identityVerso) && (
                                    <Tag color="green" className="document-status">
                                      <CheckCircleOutlined /> {newDocuments.identityVerso ? 'Nouveau' : 'Disponible'}
                                    </Tag>
                                  )}
                                </div>
                                <div className="document-content">
                                  <div className="upload-container">
                                    <Upload
                                      accept=".jpg,.jpeg,.png"
                                      maxCount={1}
                                      listType="picture-card"
                                      beforeUpload={(file) => {
                                        if (file.size > 5 * 1024 * 1024) {
                                          toast.error("Fichier trop volumineux (max 5MB)");
                                          return false;
                                        }
                                        setNewDocuments({ ...newDocuments, identityVerso: file });
                                        setUpdatedInformations({ ...updatedInformations, identity_document_verso: 'updated' });
                                        setHasChanges(true);
                                        return false;
                                      }}
                                      onRemove={() => {
                                        setNewDocuments({ ...newDocuments, identityVerso: null });
                                        const updated = { ...updatedInformations };
                                        delete updated.identity_document_verso;
                                        setUpdatedInformations(updated);
                                      }}
                                    >
                                      {newDocuments.identityVerso ? null : (
                                        <div>
                                          <UploadOutlined />
                                          <div className="mt-2">
                                            {user.identity_document_verso ? 'Remplacer' : 'Upload'}
                                          </div>
                                        </div>
                                      )}
                                    </Upload>
                                    {newDocuments.identityVerso && (
                                      <div className="upload-file-name">
                                        Nouveau fichier : {newDocuments.identityVerso.name}
                                      </div>
                                    )}
                                    {!newDocuments.identityVerso && user.identity_document_verso && (
                                      <div className="document-actions mt-2">
                                        <Button
                                          type="link"
                                          icon={<EyeOutlined />}
                                          href={docUrl(user.identity_document_verso)}
                                          target="_blank"
                                          className="btn-view"
                                        >
                                          Voir
                                        </Button>
                                        <Button
                                          type="link"
                                          icon={<DownloadOutlined />}
                                          href={docUrl(user.identity_document_verso)}
                                          download
                                          className="btn-view"
                                        >
                                          Télécharger
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Card>
                            )}

                            {/* Carte RIB */}
                            <Card className="document-card">
                              <div className="document-header">
                                <BankOutlined className="document-icon" />
                                <h6>Document RIB</h6>
                                {(user.rib_document || newDocuments.rib) && (
                                  <Tag color="green" className="document-status">
                                    <CheckCircleOutlined /> {newDocuments.rib ? 'Nouveau' : 'Disponible'}
                                  </Tag>
                                )}
                              </div>
                              <div className="document-content">
                                <div className="upload-container">
                                  <Upload
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    maxCount={1}
                                    beforeUpload={(file) => {
                                      if (file.size > 5 * 1024 * 1024) {
                                        toast.error("Fichier trop volumineux (max 5MB)");
                                        return false;
                                      }
                                      setNewDocuments({ ...newDocuments, rib: file });
                                      setUpdatedInformations({ ...updatedInformations, rib_document: 'updated' });
                                      setHasChanges(true);
                                      return false;
                                    }}
                                    onRemove={() => {
                                      setNewDocuments({ ...newDocuments, rib: null });
                                      const updated = { ...updatedInformations };
                                      delete updated.rib_document;
                                      setUpdatedInformations(updated);
                                    }}
                                  >
                                    <Button icon={<UploadOutlined />} block className="upload-button">
                                      {newDocuments.rib ? 'Modifier le RIB' : user.rib_document ? 'Remplacer le RIB' : 'Uploader le RIB'}
                                    </Button>
                                  </Upload>
                                  {newDocuments.rib && (
                                    <div className="upload-file-name">
                                      Nouveau fichier : {newDocuments.rib.name}
                                    </div>
                                  )}
                                  {!newDocuments.rib && user.rib_document && (
                                    <div className="document-actions mt-2">
                                      <Button
                                        type="link"
                                        icon={<EyeOutlined />}
                                        href={docUrl(user.rib_document)}
                                        target="_blank"
                                        className="btn-view"
                                      >
                                        Voir
                                      </Button>
                                      <Button
                                        type="link"
                                        icon={<DownloadOutlined />}
                                        href={docUrl(user.rib_document)}
                                        download
                                        className="btn-view"
                                      >
                                        Télécharger
                                      </Button>
                                    </div>
                                  )}
                                  {!newDocuments.rib && !user.rib_document && (
                                    <div className="no-document">
                                      Aucun document disponible
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Card>
                          </div>

                          {/* Guide de vérification */}
                          <Card className="mt-4">
                            <div className="document-header">
                              <InfoCircleOutlined className="document-icon" />
                              <h6>Guide de vérification</h6>
                            </div>
                            <div className="document-content">
                              <ul>
                                <li>Kbis datant de moins de 3 mois</li>
                                <li>Pièce d'identité en cours de validité</li>
                                <li>Document RIB lisible et complet</li>
                                <li>Correspondance RIB document vs RIB saisi</li>
                                <li>Correspondance des informations (SIREN, nom, BIC)</li>
                                <li>Documents lisibles et complets</li>
                              </ul>
                            </div>
                          </Card>
                        </div>
                      ) : (
                        <Alert
                          message="Compte non professionnel"
                          description="Cette section est réservée aux utilisateurs avec un compte professionnel vérifié."
                          type="info"
                          showIcon
                          action={
                            <Button
                              className="btn-professional-request"
                              size="small"
                              onClick={handleProfessionalRequest}
                              icon={<SafetyCertificateOutlined />}
                            >
                              Demander un compte professionnel
                            </Button>
                          }
                        />
                      )}
                    </div>
                  ),
                },
                {
                  key: "subscription",
                  label: (
                    <span>
                      <BellOutlined style={{ marginRight: '8px' }} /> Abonnement
                    </span>
                  ),
                  children: (
                    <div className="subscription-section">
                      <div className="subscription-card">
                        <div className="subscription-header">
                          <BellOutlined className="subscription-icon" />
                        </div>
                        <div className="subscription-content">
                          <p>Cette page d'abonnement permet de vous abonner ou de vous désabonner aux Newsletters.</p>
                          <Segmented
                            options={[
                              {
                                label: (
                                  <div className="segment-option">
                                    <BellOutlined style={{ opacity: 0.7 }} />
                                    <span>Désabonné</span>
                                  </div>
                                ),
                                value: false,
                              },
                              {
                                label: (
                                  <div className="segment-option">
                                    <BellOutlined />
                                    <span>Abonné</span>
                                  </div>
                                ),
                                value: true,
                              },
                            ]}
                            value={isSubscribed}
                            onChange={handleSubscribeToggle}
                            className="subscription-toggle"
                          />
                        </div>
                      </div>
                    </div>
                  ),
                },
              ]}
            />

            <Divider />

            <div className="actions-section">
              <div className="quick-actions">
                <CardCustomImage
                  title="Voir les tarifs"
                  image={tariffIcon}
                  color="#4BB0C0"
                  targetUrl="/tarification"
                  openInNewTab={true}
                />
              </div>

              <div className="form-actions">
                <Space>
                  <ButtonCustom
                    title="Enregistrer"
                    color={hasChanges ? "#46cbda" : "#b3b3b3"}
                    onClick={hasChanges ? handleConfirm : undefined}
                    disabled={!hasChanges}
                  />
                  <ButtonCustom
                    title="Annuler"
                    color="#E76F51"
                    onClick={handleCancel}
                  />
                </Space>
                <ButtonCustom
                  title="Changer le mot de passe"
                  color="#2A919D"
                  onClick={handleForgotPassword}
                />
              </div>
            </div>
          </Card>
        </motion.div>

        {/* Modal Professionnel */}
        <Modal
          title={
            <div className="modal-title">
              <BankOutlined />
              <span>Demande de compte professionnel</span>
            </div>
          }
          open={isProfessionalModalOpen}
          onCancel={handleCloseProfessionalModal}
          width={800}
          className="professional-modal"
          footer={
            <div className="modal-footer">
              <Button onClick={handleCloseProfessionalModal}>
                Annuler
              </Button>
              <Button
                className="btn-rib-modal"
                onClick={handleProfessionalDocumentsSubmit}
                icon={<UploadOutlined />}
              >
                Envoyer la demande
              </Button>
            </div>
          }
        >
          <div className="professional-modal-content">
            <Alert
              message="Compte Professionnel"
              description="Ce type de compte nécessite la vérification de vos documents. Votre compte sera activé sous 48h après validation."
              type="info"
              showIcon
              className="mb-4"
            />

            <ProfessionalDocumentUpload
              onDocumentsChange={setProfessionalDocuments}
            />

            <Card className="rib-section">
              <div className="rib-header">
                <BankOutlined />
                <h5>Relevé d'Identité Bancaire (RIB)</h5>
                <Tag color="red" className="required-tag">Requis</Tag>
              </div>

              {(professionalRib || professionalDocuments.ribFile) && (
                <Alert
                  message="RIB fourni"
                  description={
                    <div>
                      {professionalRib && (
                        <div>
                          <CheckCircleOutlined /> RIB saisi : {formatRIB(professionalRib)}
                        </div>
                      )}
                      {professionalDocuments.ribFile && (
                        <div>
                          <CheckCircleOutlined /> Document : {professionalDocuments.ribFile.name}
                        </div>
                      )}
                    </div>
                  }
                  type="success"
                  showIcon
                  className="mb-3"
                />
              )}

              <Button
                type="default"
                icon={<KeyOutlined />}
                size="large"
                block
                onClick={() => setRibModalVisible(true)}
                className="rib-button"
              >
                {professionalRib ? 'Modifier le RIB/BIC' : 'Saisir RIB et BIC'}
              </Button>

              <div className="rib-note">
                <InfoCircleOutlined />
                <span>Saisissez votre RIB manuellement ou uploader un document scanné</span>
              </div>
            </Card>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default GestionDeMonCompte;